import { Colors } from "../enums/Colors"

export const colorByIndex = (index: number) => {
  const enumIndex = index % Object.values(Colors).length;
  return Object.values(Colors)[enumIndex];
}